import { gql } from 'graphql-request'

export const GET_APP_SETTING = gql`
  query GET_APP_SETTING($appSettingId: Int!) {
    getAppSetting(appSettingId: $appSettingId) {
      error
      status
      data {
        id
        name
        minutesToPay
        minutesToConfirme
        enableWalletOnline
        preventSecondaryAccountOpenVideo
        preventSecondaryAccountAuthentication
        checkModerationLabelPrivateMessage
        commissionAgentRealTime
        minVersionUseAndroid
      }
    }
  }
`

export const GET_APP_SETTING_VERSION = gql`
  query GET_APP_SETTING_VERSION($appSettingId: Int!) {
    getAppSettingVersion(appSettingId: $appSettingId) {
      error
      status
      data {
        minVersionUseAndroid
      }
    }
  }
`

export const GET_APP_SETTING_PUSH = gql`
  query GET_APP_SETTING_PUSH($appSettingPushId: Int!) {
    getAppSettingPush(appSettingPushId: $appSettingPushId) {
      error
      status
      data {
        id
        name
        minTotalValueGiftSentPushLive
        minTotalValueGiftSentPushCountry
        minTotalValueGiftSentPushAllCountry
        minReturnTimeGameLuckCoinAllCountry
        minReturnValueGameLuckCoinAllCountry
        minReturnTimeGameLuckCoinCountry
        minReturnValueGameLuckCoinCountry
        minReturnTimeGameLuckCoinMiddle
        minReturnValueGameLuckCoinMiddle
        minReturnTimeGameLuckCoinChat
        minReturnValueGameGoldMiner
        minReturnTimeGameLuckCoinSound
        displayTimeGiftSentPushLive
        displayTimeGiftSentPushCountry
        displayTimeGiftSentPushAllCountry
        displayTimeGameLuckCoinAllCountry
        displayTimeGameLuckCoinCountry
        displayTimeGameLuckCoinMiddle
      }
    }
  }
`

export const GET_APP_SETTING_GAME = gql`
  query GET_APP_SETTING_GAME($appSettingGameId: Int!) {
    getAppSettingGame(appSettingGameId: $appSettingGameId) {
      error
      status
      data {
        id
        name
        gameLuckCoinMultipleCalculation
        gameGoldMinerValueBet
        gameGoldMinerDefaultGiftIdEarning
        gameGoldMinerDefaultValueGiftEarning
      }
    }
  }
`

export const GET_APP_SETTING_DEFAULT_VALUE = gql`
  query GET_APP_SETTING_DEFAULT_VALUE($appSettingDefaultValueId: Int!) {
    getAppSettingDefaultValue(
      appSettingDefaultValueId: $appSettingDefaultValueId
    ) {
      error
      status
      data {
        id
        name
        valueSubscribeSuperFan
        valueRenewSuperFan
        messageBubbleInsideRoom
        messageBubbleCountry
        messageBubbleAll
      }
    }
  }
`

export const GET_SERVER_DATE = gql`
  query GET_SERVER_DATE {
    getServerDate
  }
`

export const GET_APP_THEME_FIRST = gql`
  query GET_APP_THEME_FIRST($inUse: Boolean) {
    getAppThemeFirst(inUse: $inUse) {
      error
      status
      data {
        id
        name
        inUse
        backgroundImageUrl
        primaryColor
        secondaryColor
        textColor
      }
    }
  }
`
